import { UpdatesPageDataDto, UpdatesUnreadCountDto } from '../types'
import { getApiClient } from './apiClient'

export const fetchUserUpdatesFn = async (data: { limit?: number; lastEvaluatedKey?: string }): Promise<UpdatesPageDataDto> => {
  const response = await getApiClient().post('/updates/list', data)
  return response.data
}

export const fetchUpdatesUnreadCountsFn = async (): Promise<UpdatesUnreadCountDto> => {
  const response = await getApiClient().get('/updates/count')
  return response.data
}
